import EditContribtionPrefs from './edit_contribution_prefs'
import { reduxForm } from 'redux-form'
import { validateFunc as validateContributionPrefs } from 'components/contribution_prefs'

import { getCampaignSelector } from 'redux/selectors/campaign'
import { updateRemotely } from 'redux/modules/campaign'

import { AMOUNT_TYPES } from 'shared/shared_consts'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    validate: validateContributionPrefs(campaign.goal),
    initialValues: {
      amountType: campaign.amount_type,
      amountAtLeast: campaign.amount,
      amountExactly: campaign.amount,
    },
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      let data = {
        amount_type: formValues.amountType,
      }

      if (data.amount_type === AMOUNT_TYPES.at_least) {
        data.amount = formValues.amountAtLeast
      } else if (data.amount_type === AMOUNT_TYPES.exactly) {
        data.amount = formValues.amountExactly
      }

      return dispatch(updateRemotely(campaignId, data))
    },
  }
}

export default reduxForm(
  {
    form: 'edit_contribution_prefs',
    fields: ['amountType', 'amountAtLeast', 'amountExactly'],
  },
  mapStateToProps,
  mapDispatchToProps
)(EditContribtionPrefs)
